/**
 * Read the non-httpOnly mirror cookie set by the API server when a sales
 * presenter session is active (task #485). Used by DemoSessionTimer to hide
 * the 15-min countdown and by DemoBanner to surface the "Reset demo data"
 * button. The signed cookie is the source of truth on the server.
 */
export function readSalesPresenterCookie(): { active: boolean; expiresAt: number | null } {
  if (typeof document === "undefined") return { active: false, expiresAt: null };
  try {
    const match = document.cookie.split("; ").find((c) => c.startsWith("sales_presenter_view="));
    if (!match) return { active: false, expiresAt: null };
    const raw = decodeURIComponent(match.split("=")[1] ?? "");
    const [flag, exp] = raw.split("|");
    if (flag !== "1") return { active: false, expiresAt: null };
    const expiresAt = Number.parseInt(exp ?? "", 10);
    if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
      return { active: false, expiresAt: null };
    }
    return { active: true, expiresAt };
  } catch {
    return { active: false, expiresAt: null };
  }
}
